import { z } from 'zod';
// backup summary schema
export const backupSummarySchema = z.object({
    id: z.string(),
    budgetId: z.string().uuid(),
    budgetName: z.string(),
    backupDate: z.string().datetime(),
});
